// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3PeTD","content":"Consent_content__1VEDh","footer":"Consent_footer__x7ERx"};